import React from 'react';

import DromoImporter from './importer';
import { faUpload } from '@fortawesome/pro-solid-svg-icons';

import { Button } from 'components/ui/button';
import { showSnackbar } from 'components/ui/snackbar/helper';

import type { DromoImporterConfig, DromoImporterProps, Import } from './types';

interface Props {
  dromoImporterConfig?: DromoImporterConfig | null;
  dromoImporterProps: DromoImporterProps;
  showDromo: boolean;
  showIcon?: boolean;
  onCreate: (dromoImport: Import) => void;
  setShowDromo: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function DromoImporterButton({
  dromoImporterConfig,
  dromoImporterProps,
  showDromo,
  showIcon,
  onCreate,
  setShowDromo
}: Props) {
  return <>
    <Button
      disabled={showDromo || !dromoImporterConfig}
      icon={showIcon ? faUpload : null}
      label="Import"
      onClick={() => setShowDromo(true)}
    />

    {showDromo && dromoImporterConfig &&
      <DromoImporter
        {...dromoImporterConfig}
        {...dromoImporterProps}
        onCreate={onCreate}
        onError={() => showSnackbar({ text: 'Something went wrong.', variant: 'danger' })}
        onHide={() => setShowDromo(false)}
      />
    }
  </>;
}
